import { writable } from 'svelte/store';

// export const selNbh = writable('Boyle Heights');
export const selNbh = writable(null);
export const isMobile = writable(null);
